import React from 'react';
import { formatPercentage, getFieldColorStyle } from './helpers/cellFormatters';

const Percentage = ({ params, field }) => {
    const value = params?.value;

    if (value === null || value === '' || value === undefined) {
        return <></>;
    }

    return (
        <div
            className="text-right number-display"
            style={getFieldColorStyle(value, field)}
        >
            {formatPercentage(value)}
        </div>
    );
};

export default Percentage;
